import axios, { InternalAxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    // Don't auto-redirect on 401 - let the auth store handle it
    return Promise.reject(error);
  }
);

// API Methods
export const apiMethods = {
  // Session deletion with cascade
  deleteSession: async (sessionId: string) => {
    const response = await api.delete(`/api/sessions/${sessionId}`);
    return response.data;
  },

  // Account deletion with cascade
  deleteAccount: async () => {
    const response = await api.delete('/api/account');
    return response.data;
  },

  // Get sessions
  getSessions: async () => {
    const response = await api.get('/api/sessions');
    return response.data;
  },

  // Get session chatters
  getSessionChatters: async (sessionId: string) => {
    const response = await api.get(`/api/sessions/${sessionId}/chatters`);
    return response.data;
  },

  // Update chatter greet status
  updateChatterGreet: async (chatterId: string, isGreeted: boolean) => {
    const response = await api.put(`/api/chatters/${chatterId}/greet`, { isGreeted });
    return response.data;
  },

  // Get user settings
  getSettings: async () => {
    const response = await api.get('/api/settings');
    return response.data;
  },

  // Update user settings
  updateSettings: async (settings: any) => {
    const response = await api.put('/api/settings', settings);
    return response.data;
  }
}; 